import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { Label, Input, Select as SelectCF } from "~/componentes/CustomForm";
import { Colors } from "~/config/Colors";
import Select, { StylesConfig } from 'react-select';

import ShowConfirmacao from "~/utils/ShowConfirmacao";
import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";
import GroupAcoordion from "~/componentes/GroupAcoordion";

function CreateEditContent({ mountedData, unidades }) {
  const [idUnidades, setIdUnidades] = useState([]);
  const [idUnidadesDefault, setIdUnidadesDefault] = useState([]);
  const [unidadesSelect, setUnidadesSelect] = useState([]);
  const [centrosCustos, setCentrosCustos] = useState([]);
  const [idCentrosCustos, setIdCentrosCustos] = useState([]);
  const [centrosCustosSelect, setCentrosCustosSelect] = useState([]);
  const [idCentrosCustosDefault, setIdCentrosCustosDefault] = useState([]);

  const [modulos, setModulos] = useState([]);
  const [tipo, setTipo] = useState(
    mountedData?.tipo ? mountedData?.tipo : "CLI",
  );

  useEffect(() => {
    api
      .get("/signed/geral/acessos/check", { params: { tipo } })
      .then(response => {
        setModulos(response.data);
      });
  }, [tipo]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          idUnidades,
          idCentrosCustos,
          tipo,
        };
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/cliente/administracao/gerenciamento/grupoperfil", thisData);
        else
          response = await api.post("/signed/cliente/administracao/gerenciamento/grupoperfil", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? 'atualizar' : 'cadastrar'} esse Grupo de Perfill, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? 'atualizar' : 'cadastrar'} esse Grupo de Perfill?`,
        successModal: `Grupo de Perfill ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  useEffect(() => {
    if (idUnidades?.length > 0) {      
      api.get('/signed/cliente/gestorservico/gerenciamento/centroCustos', { params: { ativo: 1, idUnidades } }).then(response => setCentrosCustos(response.data));
    }
  }, [idUnidades]);

  useEffect(() => {
    if (unidades?.length > 0) {
      let lista = [];
      for (const item of unidades) {
        lista.push({  value: item?.id, label: item?.nome, color: "#00B8D9"})
      }
      setUnidadesSelect(lista);
    }
  }, [unidades]);

  useEffect(() => {
    if (centrosCustos?.length > 0) {
      let lista = [];
      for (const item of centrosCustos) {
        lista.push({  value: item?.id, label: item?.titulo, color: "#00B8D9"})
      }
      setCentrosCustosSelect(lista);
    }
  }, [centrosCustos]);

  useEffect(() => {
    if (unidadesSelect?.length > 0 && mountedData?.idUnidades?.length > 0) {
      let listaIdsUni = [];
      
      for (const item of mountedData?.idUnidades) {
        const find = unidadesSelect?.find((e) => e?.value == parseInt(item));
        find && listaIdsUni.push(find);
      }

      setIdUnidades(mountedData?.idUnidades);
      setIdUnidadesDefault(listaIdsUni);
    }
  }, [mountedData, unidadesSelect]);
  
  useEffect(() => {
    if (centrosCustosSelect?.length > 0 && mountedData?.idCentrosCustos?.length > 0) {
      let listaIdsCC = [];
      
      for (const item of mountedData?.idCentrosCustos) {
        const find = centrosCustosSelect?.find((e) => e?.value == parseInt(item));
        find && listaIdsCC.push(find);
      }

      setIdCentrosCustos(mountedData?.idCentrosCustos);
      setIdCentrosCustosDefault(listaIdsCC);
    }
  }, [mountedData, centrosCustosSelect]);
  
  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? Colors.Color2
          : undefined,
        color: Colors.Color7,
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : Colors.Color2
            : undefined,
        },
      };
    },
  };

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Nome *" className="col s8 m8 l8">
            <Input name="nome" defaultValue={mountedData?.nome} />
          </Label>
          <Label title="Tipo *" className="col s4 m4 l4">
            <SelectCF
              isNumber
              list={{
                list: [{ tipo: "CLI", nome: "Cliente" }],
                value: "tipo",
                label: "nome",
              }}
              name="tipo"
              defaultValue={mountedData?.tipo}
              onChange={e => {
                const v = e.currentTarget.value;
                setTipo(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          <Label title="Unidades *" className="col s12 m12 l6">
            <Select
              value={idUnidadesDefault}
              isMulti
              name="colors"
              options={unidadesSelect}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Unidades"
              onChange={(e) => {
                let ids = [];
                for (const itemE of e) {
                  ids.push(itemE?.value);
                }
                setIdUnidades(ids);

                let listaIdsUni = [];
                
                for (const item of e) {
                  const find = unidadesSelect.find((o) => o?.value == item?.value);
                  find && listaIdsUni.push(find);
                }
          
                setIdUnidadesDefault(listaIdsUni);
              }}
              styles={colourStyles}
            />
          </Label>
          <Label title="Centro de Custo *" className="col s12 m12 l6">
            <Select
              value={idCentrosCustosDefault}
              isMulti
              name="colors"
              options={centrosCustosSelect}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Centro de Custo"
              onChange={(e) => {
                let ids = [];
                for (const itemE of e) {
                  ids.push(itemE?.value);
                }
                setIdCentrosCustos(ids);
                
                let listaIdsCC = [];
                
                for (const item of e) {
                  const find = centrosCustosSelect.find((o) => o?.value == item?.value);
                  find && listaIdsCC.push(find);
                }
          
                setIdCentrosCustosDefault(listaIdsCC);
              }}
              styles={colourStyles}
            />
          </Label>
        </div>
        <div className="row">
          {modulos.length > 0 && (
            <GroupAcoordion
              defaultSelect={typeof mountedData?.acessos == "string" ? JSON.parse(mountedData?.acessos) : mountedData?.acessos}
              title={"Acessos "}
              name={"acessos"}
              itens={modulos}
            />
          )}
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
